import { FilterSelectField } from "components/formFields/FilterSelectField";

import { i18n } from "services/i18nService";
import {
  filterItemTypesByPlan,
  includeCurrentItemTypeInOptions,
} from "services/utility/misc";

import { usePlans } from "hooks/usePlans";

import { ALL_FILTER_OPTION } from "appConstants";

export function EditItemTypeFilter(props) {
  const { filters, setFilters } = props;
  const { filterSettings } = filters;
  const { Type } = filterSettings;

  const { hasAtLeastProPlan } = usePlans();

  function handleChange(_, value) {
    setFilters((prevParams) => ({
      ...prevParams,
      filterSettings: { ...prevParams.filterSettings, Type: value?.id || "" },
      startingRecord: 1,
    }));
  }

  function getOptions() {
    const planOptions = filterItemTypesByPlan(hasAtLeastProPlan);

    // add "All" option to the options
    const allOptions = [ALL_FILTER_OPTION, ...planOptions];

    // always include the current item type in options, even if it's
    // not allowed by the user's plan (such as OVERHEAD or LABOR,
    // which require at least Pro), to accomodate legacy values in data
    return hasAtLeastProPlan
      ? allOptions
      : includeCurrentItemTypeInOptions(allOptions, Type);
  }

  return (
    <FilterSelectField
      options={getOptions()}
      onValueChange={handleChange}
      value={Type ? { id: Type } : ALL_FILTER_OPTION}
      label={i18n("filter.Type")}
      dataTesting="typeFilter"
      disableClearable
    />
  );
}
